class Workspace {
  constructor(api) {
    this.api = api;
  }

  getWorkspaces(queryParams, fields, onSuccess, onError) {
    if (fields != "") {
      fields = "&include=" + fields;
    }
    let params = "";
    if (queryParams) {
      for (const [query, value] of Object.entries(queryParams)) {
        params += params === "" ? "?" : "&";
        params += query + "=" + value;
      }
    }
    return this.api.http_fibercloud
      .get("v1/workspaces?paginate=false" + params + fields, {
      })
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  getAll(includes, fields, onSuccess, onError) {
    let extras = "";
    let companyUUID = localStorage.getItem("company_uuid");
    if (includes) {
      extras += "&include=" + includes;
    }
    if (fields) {
      extras += "&fields[fc_workspace]=" + fields;
    }

    return this.api.http_fibercloud
      .get("v1/workspaces?paginate=false" + extras, {
        headers: {
          "company-uuid": companyUUID
        }
      })
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  getAllPaginated(queryParams, includes, fields, onSuccess, onError) {
    let params = "";
    if (queryParams) {
      for (const [query, value] of Object.entries(queryParams)) {
        params += params === "" ? "?" : "&";
        params += query + "=" + value;
      }
    }

    let extras = "";
    let companyUUID = localStorage.getItem("company_uuid");
    if (includes) {
      extras += "&include=" + includes;
    }
    if (fields) {
      extras += "&fields[fc_workspace]=" + fields;
    }

    return this.api.http_fibercloud
      .get("v1/workspaces" + params + extras, {
        headers: {
          "company-uuid": companyUUID
        }
      })
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  getByUUID(uuid, includes, fields, onSuccess, onError) {
    let hasExtras = includes || fields;

    let extras = "";
    if (hasExtras) {
      extras += "?";
      if (includes) {
        extras += "include=" + includes;
      }
      if (fields) {
        if (extras !== "?") {
          extras += "&";
        }
        extras += "fields[fc_workspace]=" + fields;
      }
    }
    return this.api.http_fibercloud
      .get("v1/workspaces/" + uuid + extras)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  getWorkspacesContainsObject(objectType, objectUuid, params, onSuccess, onError) {
    let extras = "";
    if (params.sort) {
      extras += "?sort=" + params.sort;
    }
    if (params.pageNumber) {
      let stringConnector = params.sort ? '&' : '?'
      extras += stringConnector + "page[number]=" + params.pageNumber;
    }
    if (!params.paginate) {
      params.paginate = false;
    }
    return this.api.http_fibercloud
      .get("v1/workspaces/object/" + objectType + "/" + objectUuid +
        // '&paginate=' + params.paginate +
        extras
      )
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  getWorkspacesLayersObject(queryParams, layer, workspaceUuid, geom, onSuccess, onError) {
    let params = "";
    if (queryParams) {
      for (const [query, value] of Object.entries(queryParams)) {
        params += params === "" ? "&" : "&";
        params += query + "=" + value;
      }
    }

    let url = "/?workspace_uuid=" + workspaceUuid;

    if(geom ){
      url = "/?geom=" + geom;
    }

    return this.api.http_fibercloud
      .get("v1/workspaces/object/" + layer + url + params + '&include=node')
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  create(data, onSuccess, onError) {
    let companyUUID = localStorage.getItem("company_uuid");
    return this.api.http_fibercloud
      .post("v1/workspaces", data, {
        headers: {
          "company-uuid": companyUUID
        }
      })
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  edit(id, data, onSuccess, onError) {
    let companyUUID = localStorage.getItem("company_uuid");
    return this.api.http_fibercloud
      .put("v1/workspaces/" + id, data, {
        headers: {
          "company-uuid": companyUUID
        }
      })
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  deleteLayerObjects(layer, data, onSuccess, onError) {
    return this.api.http_fibercloud
      .delete("v1/workspaces/object/" + layer, {data})
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  delete(id, onSuccess, onError) {
    return this.api.http_fibercloud
      .delete("v1/workspaces/" + id)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  getNetworkOfWorkspacesTree(uuid, onSuccess, onError) {
    return this.api.http_fibercloud
      .get("v1/workspaces/" + uuid + "/network")
      .then(resp => {
        onSuccess(resp.data.data);
      })
      .catch(error => {
        onError(error);
      });
  }

  downloadAll(onSuccess, onError) {
    return this.api.http_fibercloud
      .get("v1/workspaces/export/excel")
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }
}

export default Workspace;



// WEBPACK FOOTER //
// ./src/api/workspace.js